// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/bn-video.css
// module id = 2687
// module chunks = 2